import type TermClassType from "./TermClassType";

export default class Term {
    public termClass: TermClassType;
    public termUrl: string;
    public termText: string;

    public constructor(obj?: any) {
        if(obj) {
            this.termClass = obj.termClass;
            this.termUrl = obj.termUrl;
            this.termText = obj.termText;
        }
    }

    public toJSON(): object {
        return {
            termClass: this.termClass,
            termUrl: this.termUrl,
            termText: this.termText,
        }
    }

}